/* Shared loader for Shopify App Embed and single-shop theme snippet. */
(function () {
  function start() {
    var config = document.querySelector('[data-rf-livechat-config]');
    if (!config || document.querySelector('[data-rf-livechat-script], .rflc-root')) return;
    var base;
    try {
      base = new URL(config.dataset.portal);
      if (base.protocol !== 'https:' || base.username || base.password || base.search || base.hash) return;
    } catch (_) { return; }
    var version = encodeURIComponent(config.dataset.version || '20260922');
    var style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = base.origin + '/livechat/widget.css?v=' + version;
    document.head.appendChild(style);
    var script = document.createElement('script');
    script.src = base.origin + '/livechat/widget.js?v=' + version;
    script.dataset.portal = base.origin;
    script.dataset.accountPortal = config.dataset.accountPortal || 'https://mein.repairfirst.de';
    script.dataset.rfLivechatScript = '1';
    script.defer = true;
    script.onerror = function () {
      var fallback = document.createElement('a');
      fallback.href = '/pages/kontakt';
      fallback.textContent = 'Chat nicht erreichbar – Kontakt aufnehmen';
      fallback.style.cssText = 'position:fixed;right:16px;bottom:16px;z-index:9999;background:#fff;color:#111;padding:12px;border:1px solid #ddd;border-radius:8px';
      document.body.appendChild(fallback);
    };
    document.head.appendChild(script);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
